import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";

@Component({
  template: require("./template.html")
})
class LabelPaginateDisplayComponent extends Vue {
  @Prop()
  totalItems: number;

  @Prop()
  pageIndex: number;

  @Prop()
  pageSize: number;

  @Prop()
  pageCount: number;

  get recordIndex () {
    let recordIndex = this.pageIndex * this.pageSize;
    return recordIndex > this.totalItems ? this.totalItems : recordIndex;
  }
}

export default LabelPaginateDisplayComponent;
